import React from 'react'
import { Typography, Box } from '@the-platform-group/component-library'
import MergeStatusCell from './MergeStatusCell'
import { getFullName } from '@the-platform-group/formatters/people'

const DATE_FORMAT = 'MM-dd-yyyy'

const ProfileCell = ({ person, organizationName = '-' }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="body2">{getFullName(person)}</Typography>
      <Typography variant="caption" color="text.secondary">
        {organizationName}
      </Typography>
    </Box>
  )
}

export const getMergeRecordColumns = ({ onRetry }) => {
  return [
    {
      field: 'platformProfile',
      flex: 1,
      minWidth: 180,
      renderCell: ({ row }) => (
        <ProfileCell
          person={row.sourcePerson}
          organizationName={row.sourcePersonOrganization?.name}
        />
      ),
    },
    {
      field: 'platformProfileUuid',
      headerName: 'Platform Profile UUID',
      width: 160,
      valueGetter: ({ row }) => row.sourcePerson?.id,
    },
    {
      field: 'factsetProfile',
      flex: 1,
      minWidth: 180,
      renderCell: ({ row }) => (
        <ProfileCell
          person={row.targetPerson}
          organizationName={row.targetPersonOrganization?.name}
        />
      ),
    },
    {
      field: 'factsetProfileUuid',
      headerName: 'FactSet Profile UUID',
      width: 160,
      valueGetter: ({ row }) => row.targetPerson?.id,
    },
    {
      field: 'status',
      headerName: 'Merge Status',
      width: 180,
      renderCell: ({ value, row }) => (
        <MergeStatusCell
          status={value}
          onRetry={() =>
            onRetry({
              sourceId: row.data?.source_id,
              targetId: row.data?.target_id,
              jobMappings: row.data?.job_mappings,
              jobOverrides: row.data?.job_overrides,
            })
          }
        />
      ),
    },
    {
      field: 'createdAt',
      headerName: 'Date',
      type: 'date',
      dateFormat: DATE_FORMAT,
      width: 120,
    },
    {
      field: 'assignee',
      width: 140,
      valueGetter: ({ row }) => getFullName(row.user),
    },
  ]
}
